<!-- Detail page (design handoff, "Step 7"): sh-detail-header and a surface
     card per configuration. -->
<div class="page-with-header">
  <sh-loading-indicator
    *ngIf="isLoading && !seahorseModule"
    class="text-center d-block"
  ></sh-loading-indicator>

  <ng-container *ngIf="seahorseModule">
    <sh-detail-header
      backLabel="seahorseModules.seahorseModules"
      [backLink]="backLink"
      [title]="headerTitle"
      [status]="headerStatus"
      [subline]="headerSubline"
      [overflowActions]="overflowActions"
    ></sh-detail-header>

    <div class="container-fluid py-3 detail-body">
      <div class="detail-layout">
        <div class="detail-main">
          <div class="detail-stack">
            <su-seahorse-module-configuration-card
              [seahorseModule]="seahorseModule"
              [saving]="isSaving"
              (seahorseModuleChange)="updateModule()"
            ></su-seahorse-module-configuration-card>
            <su-seahorse-module-overview-configuration-card
              [seahorseModule]="seahorseModule"
              [overviewConfiguration]="seahorseModule.overviewConfiguration"
            ></su-seahorse-module-overview-configuration-card>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
